<template src="./inClub.html"></template>

<script lang="ts">
    import { axiosRequests } from '../../../services/axiosinstance';
    import { defineComponent } from 'vue';
    import { editUrl, retryGetPermissions } from '../../../services/helper';
    import { Routes } from '../../../const';
    import { TableColum, TableRow } from '../../../models/Table'
    import { Clients } from '../../../models/Clients'
    import { SelectModel } from '../../../models/GUIModels';

    interface ComponentModel {
        columTemplates: TableColum[],
        allData: any[],
        tableData: TableRow[],
        filterVip: SelectModel | null,
        filterSex: SelectModel | null,
        sex: SelectModel[],
        vip: SelectModel[],
        isShowFilters: boolean,
        isShowNewClientButton: boolean,
        isShowDownloadButton: boolean,
        isLoad: boolean,
        isCtrPressed: boolean
    }

    export default defineComponent({
        name: 'MembersInClub',
        data(): ComponentModel {
            return {
                columTemplates: [],
                allData: [],
                tableData: [],
                sex: [
                    { id: "false", text: 'clients.female', isTranslated: true, disabled: false, groupName: null },
                    { id: "true", text: 'clients.male', isTranslated: true, disabled: false, groupName: null },
                ],
                vip: [
                    { id: "false", text: 'clients.no', isTranslated: true, disabled: false, groupName: null },
                    { id: "true", text: 'clients.yes', isTranslated: true, disabled: false, groupName: null },
                ],
                filterVip: null,
                filterSex: null,
                isShowFilters: false,
                isShowNewClientButton: false,
                isShowDownloadButton: false,
                isLoad: false,
                isCtrPressed: false
            }
        },
        methods: {
            clearAllFilters: function () {
                this.filterVip = null;
                this.filterSex = null;
                this.applyFilter();
            },
            applyFilter: function () {
                this.tableData = this.allData.filter(x => {
                    if (this.filterVip == null && this.filterSex == null) {
                        return true;
                    } else if (this.filterVip != null && this.filterSex == null) {
                        if (x.data[2] == this.filterVip.id) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (this.filterVip == null && this.filterSex != null) {
                        if (x.data[1] == this.filterSex.id) {
                            return true;
                        } else {
                            return false;
                        }
                    }  else if (this.filterVip != null && this.filterSex != null) {
                        if (x.data[2] == this.filterVip.id && x.data[1] == this.filterSex.id) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }

                });
            },
            openClient: function(id: string) {
                if(!id) return;

                if (this.isCtrPressed) {
                    this.$store.commit('SET_LAST_VIEWED_CLIENT', { fi: "", id: id, buttonText: "", buttonPath: null, isNeedTranslatedButtonText: false });

                    const index = this.allData.findIndex(x => x.id.toString() == id);
                    if (index != -1) this.$store.commit('UPDATE_LAST_VIEWED_CLIENT', { fi: this.allData[index].data[0], id: id });

                    window.open('/client/' + id, '_blank');
                } else {
                    this.$store.commit('SET_LAST_VIEWED_CLIENT', { fi: "", id: id, buttonText: 'back_button.clients_in_club', buttonPath: `/clients/in-club`, isNeedTranslatedButtonText: true });

                    this.$router.push('/client/' + id);
                }
            },
            checkCtrPressed: function (e: any){
                if (e.keyCode == 17) this.isCtrPressed = true;
            },
            checkCtrDroped: function (e: any){
                if (e.keyCode == 17) this.isCtrPressed = false;
            },
            downloadFile: function () {
                axiosRequests.getFile(editUrl(Routes.downloadClientsInClub))
                    .then(
                        (data: any) => {

                            let fileName = "";

                            if (data.headers["content-disposition"]) {
                                let contentDisposittion = data.headers["content-disposition"].split(";");
                                if (contentDisposittion.length == 2) fileName = decodeURIComponent(contentDisposittion[1].trim().replace('filename=', ''));
                            }

                            if (fileName == "") {
                                this.$store.commit('SET_ADD_ERROR', 'error.error_downloading_file');
                                return;
                            }

                            let fileURL = window.URL.createObjectURL(data.data);
                            let download: any = this.$refs.download;
                            download.href = fileURL;
                            download.setAttribute('download', fileName);
                            download.click()
                        }
                    )
                    .catch(
                        async (err: any) => {
                            this.isLoad = false;

                            if (err.status == 401) {
                                return;
                            } else if (err.status == 403) {
                                this.$router.push('/forbidden');
                            } else if (err.status == 400 && err.data) {
                                this.$store.commit('SET_ADD_ERROR', err.data);
                            } else {
                                this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                            }
                        }
                    );
            },
        },
        async beforeMount() {
            window.addEventListener("keyup", this.checkCtrDroped);
            window.addEventListener("keydown", this.checkCtrPressed);

            let clientsPermission = this.$store.getters.getClientsPermission;

            if (clientsPermission.length == 0) clientsPermission = await retryGetPermissions("client");

            if (!clientsPermission?.includes('clients/in-club')) this.$router.push('/forbidden');

            this.isShowNewClientButton = clientsPermission.includes('clients/create');
            this.isShowDownloadButton = clientsPermission.includes('clients/in-club/download');

            this.isLoad = true;

            await axiosRequests.get(editUrl(Routes.getClientsInClub))
                .then(
                    (data: Clients[]) => {
                        this.columTemplates = [
                            { title: 'clients.inclub.fi', type: 'text', isSortable: true, template: '%data%' },
                            { title: 'clients.inclub.sex', type: 'sex', isSortable: true, template: '<div class="sex">%data%</div>' },
                            { title: 'clients.inclub.vip', type: 'bool', isSortable: true, template: '<div class="vip">%data%</div>' },
                            { title: 'clients.inclub.last_in', type: 'datetime', isSortable: false, template: '<div class="date"><span class="hide_in_desktop">%title%:</span>%data%</div>' },
                            { title: 'clients.inclub.duration', type: 'duration', isSortable: true, template: '<div class="date">%data%</div>' },
                        ];
                       

                        this.allData = data.map(x => { return { id: x.id, data: [`${x.lastName} ${x.firstName}`, x.sex.toString(), x.vip.toString(), x.lastIn, x.duration]}});

                        this.tableData = this.allData;

                        this.isLoad = false;
                    }
                )
                .catch(
                    async (err: any) => {
                        this.isLoad = false;

                        if (err.status == 401) {
                            return;
                        } else if (err.status == 500) {
                            this.$store.commit('SET_ISSHOWINTERNALSERVERERROR', true);
                        } else if (err.status == 403) {
                            this.$router.push('/forbidden');
                        } else if (err.status == 400 && err.data) {
                            this.$store.commit('SET_ADD_ERROR', err.data);
                        } else {
                            this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                        }
                    }
                );
        },
        beforeUnmount: function () {
             window.removeEventListener("keyup", this.checkCtrDroped);
             window.removeEventListener("keydown", this.checkCtrPressed);
        }
    });
</script>

<style scoped>
    .filter_wrapper{
        display: flex;
    }

    .table_wrapper {
        overflow: auto;
        padding-right: 10px;
    }

    .small_filter_input {
        min-width: 266px !important;
        width: 266px !important;
    }

    .clear_all_filters {
        color: #21A7D1;
        cursor: pointer;
        margin: 8px 0;
        width: fit-content;
    }

    .total {
        color: #65656F;
        margin: 0;
        font-weight: 600;
    }

    .filter_button{
        display: none;
    }

    .total_wrapper{
        display: flex;
        justify-content: space-between;
    }

    .load {
        color: #df2793;
        cursor: pointer;
        text-decoration: underline;
        margin-left: 12px;
        padding-right: 10px;
    }

    .new_client {
        color: #00a3ba;
        cursor: pointer;
        text-decoration: underline;
    }

    .new_client_mobile_button{
        display: none;
    }


    @media(max-width: 1200px) {
        .small_filter_input {
            min-width: 49% !important;
        }
    }

    @media(max-width: 960px) {
        .filter_right_wrapper {
            margin-top: 12px;
            padding-left: 0px
        }

        .load{
            display: none;
        }
    }

    @media(max-width: 500px) {
        .filter_wrapper {
            display: block;
        }

        .date_input{
            margin-top: 16px;
        }

        .show_filtes_mobile {
            display: block;
        }

        .hide_filtes_mobile{
            display: none;
        }

        .filter_button {
            display: flex;
            width: 100%;
            padding: 10px 24px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border: none;
            border-radius: 12px;
            cursor: pointer;
            background-color: #f2f2f2;
            font-size: 16px;
            line-height: 24px;
        }

        .new_client{
            display: none
        }

        .small_filter_input {
            min-width: 100% !important;
        }

        .table_wrapper {
            padding-right: 5px;
        }

        .new_client_mobile_button {
            display: flex;
            padding: 10px 24px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border: none;
            border-radius: 12px;
            cursor: pointer;
            background-color: #00a3ba;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 12px;
            margin-top: 6px;
            width: 100%;
            color: white;
        }
    }

    @media(max-width: 500px){
        :deep(.sex) {
            display: none;
        }
        
        :deep(.vip) {
            display: none;
        }

        :deep(.date) {
            background-color: #f5f5f5;
            padding: 1px 7px;
            border-radius: 12px;
            color: black;
            margin-top: 10px;
            font-size: 11px;
            letter-spacing: 1px;
            display: flex;
        }

    }
</style>
